<section class="w-full py-10 md:py-5 lg:py-14 px-4 sm:px-6 lg:px-8">
  <div class="max-w-[1250px] mx-auto">
    <div class="text-center mb-16">
      <h1 class="font-secondary text-secondary-800 text-[2.5rem] sm:text-5xl md:text-10xl lg:text-20xl font-bold mb-4">
        Jak to działa?
      </h1>
      <p class="text-primary-600 font-semibold text-base md:text-lg lg:text-xl max-w-[80%] mx-auto">
        Trzy proste kroki dzielą Cię od wymarzonego auta dla Twojej firmy
      </p>
    </div>

    <div class="bg-secondary-100 rounded-3xl shadow-xl p-6 md:p-10 lg:p-12 border border-slate-100">
      <div class="hidden md:block">
        <p-timeline [value]="timelineSteps" align="alternate">
          <ng-template pTemplate="marker" let-step>
            <div
              class="flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg shadow-blue-500/30 transition-all duration-300 hover:scale-110 hover:shadow-xl hover:shadow-blue-500/40">
              <i [class]="step.icon" class="text-white text-2xl"></i>
            </div>
          </ng-template>

          <ng-template pTemplate="content" let-step>
            <div
              class="overflow-hidden">
              <div class="px-6 pb-0">
                <h3 class="text-lg font-bold text-primary-700 font-secondary m-0">{{ step.title }}</h3>
              </div>

              <div class="px-6 py-4">
                <p class="text-slate-600 leading-relaxed m-0 text-[0.95rem]">{{ step.description }}</p>
              </div>

              @if (step.ctaText && step.ctaLink) {

                <div class="pt-2 pb-4 pl-4">
                  <p-button
                    (click)="onCtaClick()"
                    [navigator]="formComponentSignal()?.id"
                    size="small"
                    label="Przejdź"
                    [rounded]="true">
                  </p-button>
                </div>
              }
            </div>
          </ng-template>
        </p-timeline>
      </div>

      <div class="block md:hidden">
        <p-timeline [value]="timelineSteps" align="left" styleClass="timeline-no-opposite">
          <ng-template pTemplate="marker" let-step>
            <div
              class="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg shadow-blue-500/30">
              <i [class]="step.icon" class="text-white text-xl"></i>
            </div>
          </ng-template>

          <ng-template pTemplate="content" let-step>
            <div
              class="overflow-hidden ml-4">
              <div class="px-4 pb-0">
                <h3 class="text-lg font-bold text-primary-700 font-secondary m-0">{{ step.title }}</h3>
              </div>

              <div class="px-4 py-3">
                <p class="text-secondary-700 font-semibold leading-relaxed m-0 text-sm">{{ step.description }}</p>
              </div>

              @if (step.ctaText && step.ctaLink) {
                <div class="pt-2 pb-4 pl-4">
                  <p-button
                    size="small"
                    label="Przejdź"
                    [rounded]="true"
                  >
                  </p-button>
                </div>
              }
            </div>
          </ng-template>
        </p-timeline>
      </div>
    </div>
  </div>
</section>
